// Hall capacities (from the accommodation permissions list). Keep in sync with
// nssc_backend/utils/halls.js. Halls not on the list have capacity 0.
export const HALLS = {
	// Girls halls
	RLB: { name: "RLB", capacity: 30, girls: true },
	MT: { name: "MT", capacity: 20, girls: true },
	SNVH: { name: "SNVH", capacity: 60, girls: true },
	SNIG: { name: "SNIG", capacity: 0, girls: true },
	SBP: { name: "SBP", capacity: 35, girls: true },
	// ZKH: { name: "ZKH", capacity: 0, girls: true },
	// Boys halls
	ABV: { name: "ABV", capacity: 50, girls: false },
	NH: { name: "Nehru", capacity: 50, girls: false },
	MMM: { name: "MMM", capacity: 25, girls: false },
	JCB: { name: "JCB", capacity: 30, girls: false },
	GKH: { name: "Gokhale", capacity: 20, girls: false },
	AZAD: { name: "Azad", capacity: 30, girls: false },
	BCR: { name: "BC Roy", capacity: 15, girls: false },
	VS: { name: "VS", capacity: 35, girls: false },
	MS: { name: "MS", capacity: 40, girls: false },
	UBS: { name: "LBS", capacity: 40, girls: false },
	HJB: { name: "HJB", capacity: 30, girls: false },
	PAT: { name: "Patel", capacity: 0, girls: false },
	LLR: { name: "LLR", capacity: 0, girls: false },
	BRH: { name: "BRH", capacity: 0, girls: false },
	RK: { name: "RK", capacity: 0, girls: false },
	RP: { name: "RP", capacity: 0, girls: false },
};

export const isFemale = (gender) =>
	String(gender || "").trim().toLowerCase() === "female";

// Halls a participant of the given gender may be allotted to.
export const hallsForGender = (gender) =>
	Object.entries(HALLS).filter(([, h]) => (isFemale(gender) ? h.girls : !h.girls));

export const totalCapacity = (girls) =>
	Object.values(HALLS)
		.filter((h) => h.girls === girls)
		.reduce((t, h) => t + h.capacity, 0);
